import PopupConstants from '../PopupConstants';

export const DEFAULT_STATE = 3;

const zIndex = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case PopupConstants.CREATE_POPUP:
    case PopupConstants.MOVE_POPUP:
      return state + 1;
    case PopupConstants.SET_Z_INDEX:
      return action.zIndex;
    default:
      return state;
  }
};

export default zIndex;



// WEBPACK FOOTER //
// ./src-react/Popups/PopupsReducer/zIndex.jsx